import React, {Component} from "react";
import './PlaybackPanel.scss';

import {formatSecondsToMinuteSecons} from '.././../utils/utils';

class PlaybackPanel extends Component {

	constructor(props) {
		super(props);
		// create a ref to store the thumb elemeent and background to later retrieve the size
		this.thumb 				= React.createRef();
		this.timelineBackground = React.createRef();

		this.thumbSize 			= null;
		this.isThumbSelected	= false;

		// Store timeline size in the state to trigger re-render with setState when window size changes
		this.state = {
			timelineBackgroundSize: null,
		}
	}

	componentDidMount() {
		// Retrieve elements size to calculate position of thumbnail
		this.thumbSize = this.thumb.current.offsetWidth;
		this.timelineBackgroundSize = this.timelineBackground.current.offsetWidth;
		this.setState({
			timelineBackgroundSize: this.timelineBackground.current.offsetWidth
		});

		let backgroundLeftOffset = this.timelineBackground.current.getBoundingClientRect().left;
		// On window resize => Update saved size of the timeline backgroudn to be able to adjust the position of the thumb accordingly
		window.onresize = () =>{
			this.setState({
				timelineBackgroundSize: this.timelineBackground.current.offsetWidth
			});
			backgroundLeftOffset = this.timelineBackground.current.getBoundingClientRect().left;
		};

		// Bing draggable thumbnail
		this.thumb.current.addEventListener('click', function (e) {
			e.stopPropagation();
		});
		this.thumb.current.addEventListener('mousedown', (e) =>  {
			this.props.pausePlayState();
			this.isThumbSelected = true;
		});
		let previousNavTo = null;
		document.addEventListener('mousemove', (e) => {
			if( this.isThumbSelected ){
				let newPos 	= e.pageX - backgroundLeftOffset,
					navTo 	= newPos * this.props.videoDuration / this.state.timelineBackgroundSize;

				if( navTo !== previousNavTo){
					this.props.updateNavTo( navTo );
					previousNavTo = navTo;
				}
				e.preventDefault();
			}
		});
		document.addEventListener('mouseup', () => {
			this.isThumbSelected = false;
		});

		// Bind keyboard toggleing play pause
		document.addEventListener("keydown", (e) => {
			if( e.keyCode === 32 && this.props.videoReady){
				this.props.toggleCurrentPlayState();
			}
		});
	}

	/**
	 * Return thumbposition on timeline providing the current playbacktime
	 * @return {*}
	 */
	getThumbPosition = () => {
		return this.props.videoDuration ? (this.props.currentPlaybackTime * this.timelineBackgroundSize /  this.props.videoDuration - (this.thumbSize / 2) ) * 100 / this.timelineBackgroundSize  : null;
	};

	/**
	 * On Click on timeline -> navigate to time
	 * @param e
	 */
	onClickOnTimeline = (e) => {
		let x 		= e.pageX - e.currentTarget.offsetLeft,
			navTo 	= x * this.props.videoDuration / this.state.timelineBackgroundSize;

		// Navigate to clicked position
		if( navTo >= 0 ){
			this.props.pausePlayState(); // TODO: necessary ?
			this.props.updateNavTo(navTo);
		}
	};

	render() {
		return (
			<div className="playbackContent">
				<button
					onClick={this.props.toggleCurrentPlayState}
					disabled={!this.props.videoReady}
					className={`playbackContent__button ${this.props.currentlyPlaying ? 'playbackContent__button--playing' : ''}`}
					onKeyDown={(e) => { // To avoid 'space' for firing the button click
						e.preventDefault();
						return false;
					}}
				/>

				<div
					className={`playbackContent__timeline ${!this.props.videoReady ? 'playbackContent__timeline--laoding' : ''}`}
					onClick={this.onClickOnTimeline}
				>
					<div
						className={`playbackContent__thumb`}
						ref={this.thumb}
						style={{
							left: `${this.getThumbPosition()}%`
						}}
					>
					</div>

					<div
						className={`playbackContent__backgroundLine`}
						ref={this.timelineBackground}
					>
					</div>
				</div>

				<div
					className={`playbackContent__indication ${!this.props.videoReady ? 'playbackContent__indication--laoding' : ''}`}
				>
					<span
						className={`playbackContent__indicationText playbackContent__indicationText--left`}
					>
						{formatSecondsToMinuteSecons(this.props.currentPlaybackTime) }
					</span>
					<span
						className={`playbackContent__indicationText playbackContent__indicationText--middle`}
					>
						/
					</span>
					<span
						className={`playbackContent__indicationText playbackContent__indicationText--right`}
					>
						 {formatSecondsToMinuteSecons(this.props.videoDuration)}
					</span>
				</div>

			</div>
		)
	}
}

export default PlaybackPanel;